import { request } from "../../backend";
import { Agreement } from "../../models/Agreement";

export async function fetchAgreements(): Promise<Agreement[]> {
  const { agreements } = await request('/agreements');
  return agreements?.map((agreement: Partial<Agreement>) => new Agreement(agreement));
}